import React from "react";
import Loader from 'react-loader-spinner'
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, translate } from "../../utils/useful";
import FixedView from "../FixedView";
// import Modal from "../Modal";


class LookupInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        // lastNewId: 0

    }

    toggleOpen = (open) => {
        // console.log("HERE")
        let openState = open != null ? open : !this.state.isOpen

        if (openState) {
            // document.addEventListener('mousedown', this.fixedView.hideView);
            // window.addEventListener('scroll', this.fixedView.showView, true);
            // this.getPosition()
            this.fixedView.showView()

        } else {
            // document.removeEventListener('mousedown', this.fixedView.hideView);
            // window.removeEventListener('scroll', this.fixedView.showView);
            this.fixedView.hideView()


        }


        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }

    // openBox = () => {

    //     if (!this.state.isOpen) {
    //         document.addEventListener('mousedown', this.closeBox);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: true, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);
            // this.refs.icon.classList.toggle("rotate-180")
        }
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }


    changeItem = (prop, selected, dontChangeValue) => {

        // console.log("CHANGE")
        let info = this.props.header?.information
        let choosen = this.state.choosen
        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })

        if (info.multiple) {


            if (selected) {
                for (let i = 0; i < choosen.length; i++) {

                    if (choosen[i].value == prop.value) {
                        choosen.splice(i, 1)
                    }
                }
            } else {
                choosen.push(prop)
            }

            setTimeout(() => {
                this.toggleOpen(true)
            }, 1);

        } else {

            choosen = prop

            setTimeout(() => {
                this.toggleOpen(false)
            }, 1);
        }

        this.setState({ choosen }, () => {
            if (!dontChangeValue) this.changeValue()
        })



        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })

        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        // console.log('LOOku[INPUT')
        this.init()

    }

    componentDidUpdate(prevProps) {
        // console.log('this.props.forceInputUpdate', this.props.forceInputUpdate)
        // if (this.props.data && (JSON.stringify(prevProps.data) != JSON.stringify(this.props.data) && this.mounted)) {
        //     this.init()
        // }
        if (this.props.forceInputUpdate && this.props.forceInputUpdate[this.props.header.key] && (this.props.forceInputUpdate[this.props.header.key] != prevProps.forceInputUpdate[this.props.header.key])) {
            this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {
        // console.log(this.props.header.information)
        // if (this.props.header.information) {
        //     if (this.props.header.information.type == "local") {

        //         let options = []
        //         let choosen = []

        //         if (this.props.header.information.items && this.props.header.information.items.length > 0) {
        //             options = this.props.header.information.items
        //         }

        //         if (this.props.title && Array.isArray(this.props.title)) {
        //             this.props.title.forEach(element => {
        //                 choosen.push({ title: element, value: element })
        //             });
        //         }
        //         // console.log(this.props.title)
        //         this.setState({ options, choosen })
        //     } else if (this.props.header.information.type == "api") {
        // console.log(this.props.title)
        this.fetch()
        // }
        // }
    }


    fetch() {

        // console.log('this.props.variables',this.props.variables);
        this.setState({ isLoading: true })
        let info = this.props.header.information
        let address = info?.address ?? "getWidgetRecords"
        let body = {}
        let filter = (typeof info?.filter == "string" ? JSON.parse(info?.filter) : info?.filter)

        if (filter && typeof filter == 'object') {
            for (const [key, value] of Object.entries(filter)) {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }
        }


        // console.log(address, filter);


        setTimeout(() => {

            if (this.props.variables) {

                let variables = JSON.parse(JSON.stringify(this.props.variables))

                // console.log(variables)
                if (filter?.frame && filter?.frame == '{{replace-frame}}' && variables?.frameId) {
                    filter.frame = variables?.frameId
                }
                if (filter?.applet && filter?.applet == '{{replace-applet}}' && variables?.appletId) {
                    filter.applet = variables?.appletId
                }
            }

            body = { filter }

            if (info.collection) {
                body.frame = info.collection
            }

            if (info.frame) {
                body.frame = info.frame
            }



            // console.log(address, body)
            HttpService.request((address), body, (fetchResult, fetchError) => {
                // console.log(fetchResult, fetchError)
                if (fetchError) { return }

                // console.log(fetchResult)
                // fetch(address, {
                //     method: 'POST',
                //     body: JSON.stringify(filter),
                //     headers: headers
                // }).then(response => response.json()).then(data => {
                // console.log(data)
                // if (data.status == 200 && this.mounted) {
                var newData = []
                fetchResult.info.forEach(element => {

                    var newTitle = this.spliter(element, (this.props.header.information.field ?? this.props.header.information.fields?.title))
                    var newValue = this.spliter(element, (this.props.header.information.fields?.value ?? '_id'))

                    newData.push({ value: newValue, title: newTitle })
                    // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                    // var newValue = this.spliter(element, this.props.header.information.fields.value)

                    // newData.push({ value: newValue, title: newTitle })
                });


                let data = this.props.data
                let choosen

                if (Array.isArray(data)) {
                    let choosen = []
                    data.forEach(oneTitle => {
                        let oneTitleId = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
                        newData.forEach(oneNewData => {

                            if (oneNewData.value == oneTitleId) {
                                choosen.push({ title: oneNewData.title, value: oneTitleId })
                            }
                        });

                    })

                } else {

                    newData.forEach(oneNewData => {
                        let dataId = data?._id ?? data
                        if (oneNewData.value == dataId) {
                            choosen = { title: oneNewData.title, value: dataId }
                        }
                    })

                }

                this.setState({ choosen, options: newData, isLoading: false })


            })

            // }).catch(error => this.setState({ error, isLoading: false }));
        }, 300);
    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    // conditionalSettings(param, condition) {
    //     if (this.props.settings) {
    //         if (this.props.settings[param] == condition) {
    //             return true
    //         }
    //     }
    //     return false
    // }


    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })
        if (!this.state.isOpen) {
            this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData })
            await this.setState({ tempData: [] })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.tempData.forEach(element => {
                if (String(element.title).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ options: values })

            // }
        }
    }


    removeItem(index) {
        let choosen = [...this.state.choosen]
        choosen.splice(index, 1)
        this.setState({ choosen }, () => {
            this.changeValue()
        })
    }


    addTag() {
        let tempData = [...this.state.tempData]
        let choosen = [...this.state.choosen]

        let item = { title: this.state.title, value: this.state.title }
        tempData.push(item)
        // choosen.push(item)
        this.setState({ tempData }, () => {
            this.changeItem(item, false)
        })
        this.refs.input.focus()
    }

    changeValue() {
        let choosen = []
        if (Array.isArray(this.state.choosen)) {

            this.state.choosen.forEach(element => {
                choosen.push((typeof element.value == 'object' ? element.value._id : element.value))

            });
        } else {
            choosen = this.state.choosen?.value
            if (choosen === '') {
                choosen = null
            }
        }

        this.props.changeValue(this.props.header.key, choosen, this.props.extra)
    }

    AddRecordModal = () => {
        // console.log('this.props.header.information', this.props.header.information.collection)
        if (this.props.functionsHandler) {
            this.props.functionsHandler(null, 'addNewLookUp', { frame: this.props.header.information.collection, headerKey: this.props.header.key, address: this.props.header.information.address })
        }
    }


    renderOption(options, group, level) {

        return (
            <div className="w-100 mt-1">
                {group && (
                    <p className="text-bold font-size-14 mb-1" style={{ paddingLeft: level == null ? 12 : ((level ?? 0) * 10) + 3, paddingRight: level == null ? 12 : ((level ?? 0) * 10) + 10, }}>{checkTranslation(group.label)}</p>
                )}
                {Array.isArray(options) && (
                    options.map((prop, index) => {
                        let selected = false
                        if (Array.isArray(this.state.choosen)) {
                            for (var i = 0; i < this.state.choosen.length; i++) {

                                if (prop.value == this.state.choosen[i].value) {
                                    selected = true
                                }
                            }
                        } else {
                            if (prop.value == this.state.choosen?.value) {
                                selected = true
                            }
                        }
                        return (
                            <div key={index} onClick={() => this.changeItem(prop, selected)} className=" py-2 cursor-pointer select-item-hover " style={{ paddingLeft: level == null ? 15 : ((level ?? 0) * 10) + 10, paddingRight: level == null ? 15 : ((level ?? 0) * 10) + 10, backgroundColor: selected ? '#78b2d030' : null, borderBottom: '1px solid #fff' }}>
                                <p className="main-c2 text-small" style={{}}>{checkTranslation(prop.title)}</p>
                                {prop.description && (
                                    <p className=" text-smaller text-capitalize" style={{ color: '#777' }}>{checkTranslation(prop.description)}</p>
                                )}
                            </div>
                        )
                    })
                )}

                {(!Array.isArray(options) && options != null && typeof options == 'object') && Object.entries(options)?.map(([key, value], index) => {
                    return this.renderOption(options[key]?.children, options[key], (level + 1))
                })}


            </div>
        )
    }





    render() {

        let info = this.props.header?.information

        return (

            <div className='w-100' style={{ position: 'relative', }} ref={el => this.currentNode = el}>

                <div className="w-100 h-100 cusrsor-pointer" style={{ position: 'relative' }} onClick={() => !this.props.header.information?.disabled ? this.toggleOpen(true) : ''} >
                    {/* <select value={dataValue} disabled={this.props.disabled || this.props.header.information?.disabled} onChange={e => { this.changeValue(e) }} className=' form-control' style={{ WebkitAppearance: 'none', border: 'none', boxShadow: 'none', backgroundColor: 'transparent', color: '#3b3a40', width: '100%', padding: 0 }}>
                        <option disabled={this.props.header.information.required ? true : false} hidden={this.props.header.information.required ? true : false} value={''}>Select ...</option>
                        {Array.isArray(this.state.options) && this.state.options?.map((prop, index) => {

                            return (
                                <option key={index} value={prop.value}>{prop.title}</option>
                            )
                        })}
                    </select> */}


                    {(!this.state.choosen || this.state.choosen?.length == 0) && (
                        <div className="h-100 flexc w-100 cursor-pointer" style={{}}>
                            <p className={' input-value placeholder '}>{this.props.header.information?.placeholder ? checkTextTranslation(this.props.header.information.placeholder) : translate("Select ...")}</p>
                        </div>
                    )}


                    {/* {console.log('this.state.choosenkj', this.state.choosen)} */}
                    {this.state.choosen && (
                        <div className='w-100 flexc'>

                            {Array.isArray(this.state.choosen) ? (
                                <div style={{ flexWrap: 'wrap', cursor: 'pointer', display: 'flex', }}>
                                    {
                                        this.state.choosen.map((prop, index) => {
                                            return (
                                                <div key={index} className="" style={{ display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                                    <div className="flexcc" key={index} style={{ padding: 5, backgroundColor: '#eee', borderRadius: 20, marginRight: 2, marginLeft: 2, flexWrap: 'nowrap', paddingLeft: 7, paddingRight: 7 }}>

                                                        <button onClick={(e) => { e.stopPropagation(); this.changeItem(prop, true, null, true) }} className="br-20 p-1 flexcc mrd-1" style={{ backgroundColor: '#ffffffcc', width: 16, height: 16 }}>
                                                            <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 12, height: 12, }} alt="" />
                                                        </button>


                                                        <p style={{ whiteSpace: 'nowrap', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: '#202020' }}>{checkTranslation(prop.title)}</p>

                                                    </div>

                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            ) : (
                                <div className="h-100 cursor-pointer flexc" style={{ color: this.state.choosen?.color ?? '', backgroundColor: this.state.choosen?.background ?? '', border: this.state.choosen?.background ? '1px solid #eee' : null, height: 26, minWidth: 26, borderRadius: 6 }} >
                                    <p className={'input-value white-space-nowrap'} >{this.state.choosen.title ? checkTranslation(this.state.choosen.title) : checkTranslation(this.state.choosen.description)}</p>
                                    {info?.showDropdownIcon && (
                                        <div className="flexcc " style={{ paddingTop: 3 }}>
                                            <img className="mld-1 " src="/assets/icons/useful/down-arrow (3).png" alt="" height={14} />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}


                    {info.showInfo == true && (
                        <p onClick={() => { if (!this.state.isLoading) { this.props.showInfo(this.props.header.information.filter, this.props.data, this.props.settings.url, this.props.settings.page) } }} style={{ fontSize: 13, color: this.state.isLoading ? '#789' : '#007aff', marginTop: 3, cursor: 'pointer', marginLeft: 3 }}>Show information</p>
                    )}

                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: 0, right: 10 }}>
                            <Loader
                                type="Oval"
                                color="rgba(0,122,255,1)"
                                height="25"
                                width="25"
                            />
                        </div>
                    )}

                </div>


                <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={0} zIndex={15} xOffset={0} rightAlign={false}>

                    <div className="flex-column" style={{ display: 'flex', width: '100%', maxWidth: 300, zIndex: 40, backgroundColor: '#ffffff', borderColor: '#eee', borderRadius: 6, boxShadow: '0px 0px 30px rgba(0,0,0,0.2)' }}>
                        <div className={'search-drop-down   py-1 pb-2'} style={{ display: 'flex', flexDirection: 'column', width: '100%', maxHeight: 250, overflow: 'auto', }}>
                            {this.props.header.information.isSearchable && (
                                <input onChange={event => this.search(event.target.value)} placeholder={translate("search")} style={{ fontSize: 14, alignSelf: 'stratch', padding: 5, height: 35, backgroundColor: '', border: '0px', borderBottom: '1px solid #eee' }} className={'text-start text-semibold px-3'} />
                            )}

                            {this.state.groupedOptions ? (
                                <div>
                                    {Object.values(this.state.groupedOptions).map((group, index) => {
                                        return (
                                            this.renderOption(group.children, group, 1)
                                        )
                                    })}
                                </div>
                            ) : (
                                this.renderOption(this.state.options)
                            )}



                            {this.state.options.length == 0 && (
                                <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                    <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                    {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)}

                                </div>
                            )}



                        </div>

                        <div className="w-100 " style={{ borderTop: '1px solid #eee', position: 'sticky', textAlign: 'start', bottom: 0, backgroundColor: '#fff' }}>
                            <button onClick={() => this.AddRecordModal()} className="py-2 px-2 cursor-pointer br-10" style={{}}>
                                <p className="main-c2 text-small text-link">+{translate("Add new")}</p>
                            </button>
                        </div>
                    </div>
                </FixedView>




            </div >
        )
    }
}


export default LookupInput;
